import React, { KeyboardEvent, ChangeEvent } from 'react';
import { FormControl, FormHelperText, Box, TextField, Chip } from '@material-ui/core';

interface TeamMembersFieldProps {
  value?: string[];
  onAdd: (e: KeyboardEvent<HTMLInputElement>) => void;
  onDelete: (member: string) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

export const TeamMembersField = ({
  value,
  onAdd,
  onDelete,
  onChange,
  error,
  errorMessage,
  disabled,
}: TeamMembersFieldProps) => (
  <FormControl margin="normal" fullWidth error={error} disabled={disabled}>
    <TextField
      label="Application Team Members"
      onKeyDown={onAdd}
      onChange={onChange}
      error={error}
    />
    <FormHelperText error={false}>
      Add team members (press Enter to add)
    </FormHelperText>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: 1 }}>
      {value?.map((member: string) => (
        <Chip
          key={member}
          label={member}
          onDelete={() => onDelete(member)}
          color="primary"
          variant="outlined"
          style={{ margin: '4px' }}
        />
      ))}
    </Box>
    {errorMessage && (
      <FormHelperText error>{errorMessage}</FormHelperText>
    )}
  </FormControl>
); 